import { render, staticRenderFns } from "./print-view.vue?vue&type=template&id=61f83e6e&"
import script from "./print-view.vue?vue&type=script&lang=ts&"
export * from "./print-view.vue?vue&type=script&lang=ts&"
import style0 from "./print-view.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
